import {useCustomerAnalysisSteps} from "./steps/useCustomerAnalysisSteps.tsx";
import {StepsWrapper} from "../components/stepper/StepsWrapper.tsx";

export function CustomerAnalysisProcess() {
    const steps = useCustomerAnalysisSteps()
    return <StepsWrapper steps={steps} />
}